// extracted by mini-css-extract-plugin
export default {"noData":"NoData_noData__DpIRG","imageBox":"NoData_imageBox__nCbGd","text":"NoData_text__NqHkv"};